import {CrudSort, GetListParams, GetOneParams} from '@refinedev/core';
import qs from 'qs';

const mappingSortOrder = {
  ASC: 'asc',
  DESC: 'desc',
};

// converter between react-admin format and qs object (query string)
// [{field:field1, order:value1},...] => {field1:value1}
function Sort_to_QSObject(sorters?: CrudSort[]) {
  if (!sorters) return;
  var out = {};
  for (const s of sorters) {
    out[s.field] = mappingSortOrder[s.order] || s.order;
  }
  return out;
}

// {field1:value1} => {field:field1, order:value1}
function QSObject_to_Sort(sort) {
  if (!sort) return;
  // (Array.isArray(sort) ? sort : [sort]).forEach(s => {
  for (const field in sort) {
    const value = sort[field];
    return {
      field: field,
      order: value,
    };
  }
  // });
}

// qs object => ra-filter format
// {field1:{op:value1}} => {field1:value1}
function QSObject_to_Filters(filters) {
  const outputFilters = {};
  if (filters) {
    for (const field in filters) {
      const op = filters[field];
      const value = op.equals;
      outputFilters[field] = value;
    }
  }
  return outputFilters;
}

const mappingFilterOperator = {
  eq: '=',
  ne: '!=',
  lt: '<',
  gt: '>',
  lte: '<=',
  gte: '>=',
  in: 'in',
  contains: 'like',
};

export function Params_to_QueryString(params: GetListParams | GetOneParams) {
  // GetOneParams
  let query: any = {};
  if ('id' in params) {
    query = {
      id: params.id,
      meta: {...params.meta, queryContext: undefined},
    };
  } else {
    let _search: string | undefined = undefined;
    var remainFilters = {};
    if ('filters' in params && params.filters) {
      for (var f of params.filters) {
        var ff = f as any;
        if (ff.field === '_search') {
          _search = ff.value;
        } else {
          const op = mappingFilterOperator[ff.operator] || ff.operator;
          const field___op = `${ff.field}___${op}`;
          remainFilters[field___op] = ff.value;
        }
      }
    }

    query = {
      pagination: !params.pagination
        ? undefined
        : {
            page: params.pagination.current,
            perPage: params.pagination.pageSize,
          },
      orderBy: Sort_to_QSObject(params.sorters),
      search: _search,
      filters: remainFilters, //RaFilters_to_QSObject(filters),
      meta: {...params.meta, queryContext: undefined},
    };
  }

  const s = qs.stringify(query);
  return s.length > 0 ? '?' + s : '';
}

export function QueryString_to_Params(s) {
  const {sort, filters, pagination, meta, ...rest} = qs.parse(s);
  return {
    sort: sort ? QSObject_to_Sort(sort) : undefined,
    filter: filters ? QSObject_to_Filters(filters) : undefined,
    pagination,
    meta,
    ...rest,
  };
}
